/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlChallengeEmailRequest
 */
export interface ControlChallengeEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlChallengeEmailRequest
     */
    mfa_token: string;
}

/**
 * Check if a given object implements the ControlChallengeEmailRequest interface.
 */
export function instanceOfControlChallengeEmailRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mfa_token" in value;

    return isInstance;
}

export function ControlChallengeEmailRequestFromJSON(json: any): ControlChallengeEmailRequest {
    return ControlChallengeEmailRequestFromJSONTyped(json, false);
}

export function ControlChallengeEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlChallengeEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mfa_token': json['mfa_token'],
    };
}

export function ControlChallengeEmailRequestToJSON(value?: ControlChallengeEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mfa_token': value.mfa_token,
    };
}

